import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import "../Backtotop/Backtotop.css"; 

const Backtotop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    const triggerHeight = window.innerHeight * 1; // 120vh
    setVisible(scrolled > triggerHeight);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  return (
    <button
      className={`back-to-top ${visible ? "show" : ""}`}
      onClick={scrollToTop}
      aria-label="Back to top"
    >
      <FaArrowUp className="icon" />
    </button>
  );
};

export default Backtotop;
